function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeWidth=".15" d="M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm0-1.053A8.947 8.947 0 1 0 3.053 12 8.947 8.947 0 0 0 12 20.947zm-.526-10.3a.526.526 0 0 1 1.053 0v6.09a.526.526 0 1 1-1.053 0zm0-4.06a.526.526 0 1 1 1.053 0V7.94a.526.526 0 1 1-1.053 0z" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
});